'use client'

import { useEffect } from 'react'
import { reportRumError } from '~/src/lib/reportRumError'

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

/**
 * Last-resort App Router boundary: replaces the root layout entirely, so it
 * must render its own <html>/<body> and cannot rely on providers, global CSS,
 * or any component that touches app context. Minimal inline markup only.
 */
export default function GlobalError({
  error,
  reset,
}: GlobalErrorProps): React.ReactElement {
  useEffect(() => {
    console.error(error)
    reportRumError(error)
  }, [error])

  return (
    <html lang='en'>
      <body
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: '1rem',
          margin: 0,
          padding: '1rem',
          textAlign: 'center',
          fontFamily: 'system-ui, sans-serif',
        }}
      >
        <h1 style={{ fontSize: '1.25rem', fontWeight: 700 }}>Error</h1>
        <p style={{ fontSize: '1.875rem', fontWeight: 900, maxWidth: '28rem' }}>
          Looks like we&apos;re having issues, we&apos;re sorry
        </p>
        <button
          type='button'
          onClick={() => reset()}
          style={{
            padding: '0.5rem 1.25rem',
            borderRadius: '9999px',
            border: '1px solid #000',
            background: '#000',
            color: '#fff',
            cursor: 'pointer',
          }}
        >
          Try again
        </button>
      </body>
    </html>
  )
}
